import { serviceMaker } from "..";
import { IPagination } from "../../data/AppInterface";
import { TBitValue } from "../../data/AppType";
import { ITaxComponentsAdvancedSearch } from "../../screens/tax-components/TaxComponentsController";
import { API_ENDPOINTS } from "../../utils/ApiEndPoint";

// ----------------------------start tax category ---------------------------

export interface ITaxCategoryPayload {
  id?: string;
  category_name: string;
  can_individual_assign_to_item: TBitValue;
}

export const GET_ALL_TAX_CATEGORY = (pagination: IPagination, search: string) =>
  serviceMaker(
    API_ENDPOINTS.get_all_tax_category.url +
      `?perPageRows=${pagination.perPageRows}&currentPage=${
        pagination.currentPage
      }&sortBy=${pagination.sortBy}&orderBy=${pagination.orderBy}${
        search.length > 0 ? `&search=${encodeURIComponent(search)}` : ""
      }`,
    API_ENDPOINTS.get_all_tax_category.method,
  );

export const GET_TAX_CATEGORY_BY_ID = (id: string) => {
  return serviceMaker(
    API_ENDPOINTS.get_all_tax_category.url + `/${id}`,
    API_ENDPOINTS.get_all_tax_category.method,
  );
};

export const DELETE_TAX_CATEGORY = (id: string) => {
  return serviceMaker(
    API_ENDPOINTS.delete_tax_category.url + `/${id}`,
    API_ENDPOINTS.delete_tax_category.method,
  );
};

export const CREATE_TAX_CATEGORY = (payload: ITaxCategoryPayload) => {
  return serviceMaker(
    API_ENDPOINTS.create_tax_category.url,
    API_ENDPOINTS.create_tax_category.method,
    payload,
  );
};

export const UPDATE_TAX_CATEGORY = (
  payload: ITaxCategoryPayload,
  id: string,
) => {
  return serviceMaker(
    API_ENDPOINTS.update_tax_category.url + `/${id}`,
    API_ENDPOINTS.update_tax_category.method,
    payload,
  );
};

// ---------------------------- end tax category ---------------------------

// ----------------------------start tax components ---------------------------
export interface ITaxComponentsPayload {
  id?: string;
  name: string;
  rate: number | null;
  tax_category_id: string | null;
}

export const GET_ALL_TAX_COMPONENTS = (
  pagination: IPagination,
  search: string,
  advanceSearch: ITaxComponentsAdvancedSearch,
) => {
  const searchTaxCategory = advanceSearch.taxCategory
    ? `&tc=${advanceSearch.taxCategory}`
    : "";
  return serviceMaker(
    API_ENDPOINTS.get_all_tax_components.url +
      `?perPageRows=${pagination.perPageRows}&currentPage=${
        pagination.currentPage
      }&sortBy=${pagination.sortBy}&orderBy=${pagination.orderBy}${
        search.length > 0 ? `&search=${encodeURIComponent(search)}` : ""
      }${searchTaxCategory}`,
    API_ENDPOINTS.get_all_tax_components.method,
  );
};
export const GET_TAX_COMPONENT_BY_ID = (id: string) => {
  return serviceMaker(
    API_ENDPOINTS.get_all_tax_components.url + `/${id}`,
    API_ENDPOINTS.get_all_tax_components.method,
  );
};

export const DELETE_TAX_COMPONENT = (id: string) => {
  return serviceMaker(
    API_ENDPOINTS.delete_tax_component.url + `/${id}`,
    API_ENDPOINTS.delete_tax_component.method,
  );
};

export const CREATE_TAX_COMPONENT = (payload: ITaxComponentsPayload) => {
  return serviceMaker(
    API_ENDPOINTS.create_tax_component.url,
    API_ENDPOINTS.create_tax_component.method,
    payload,
  );
};

export const UPDATE_TAX_COMPONENT = (
  payload: ITaxComponentsPayload,
  id: string,
) => {
  return serviceMaker(
    API_ENDPOINTS.update_tax_component.url + `/${id}`,
    API_ENDPOINTS.update_tax_component.method,
    payload,
  );
};
// ----------------------------end tax components ---------------------------

// ----------------------------start tax Group ---------------------------
export interface ITaxGroupPayload {
  id?: string;
  name: string;
  company_state: (string | undefined)[];
  other_state: (string | undefined)[];
}
export const GET_ALL_TAX_GROUPS = (pagination: IPagination, search: string) =>
  serviceMaker(
    API_ENDPOINTS.get_all_tax_groups.url +
      `?perPageRows=${pagination.perPageRows}&currentPage=${
        pagination.currentPage
      }&sortBy=${pagination.sortBy}&orderBy=${pagination.orderBy}${
        search.length > 0 ? `&search=${encodeURIComponent(search)}` : ""
      }`,
    API_ENDPOINTS.get_all_tax_groups.method,
  );
export const GET_TAX_GROUP_BY_ID = (id: string) => {
  return serviceMaker(
    API_ENDPOINTS.get_all_tax_groups.url + `/${id}`,
    API_ENDPOINTS.get_all_tax_groups.method,
  );
};
export const DELETE_TAX_GROUP = (id: string) => {
  return serviceMaker(
    API_ENDPOINTS.delete_tax_group.url + `/${id}`,
    API_ENDPOINTS.delete_tax_group.method,
  );
};
export const CREATE_TAX_GROUP = (payload: ITaxGroupPayload) => {
  return serviceMaker(
    API_ENDPOINTS.create_tax_group.url,
    API_ENDPOINTS.create_tax_group.method,
    payload,
  );
};

export const UPDATE_TAX_GROUP = (payload: ITaxGroupPayload, id: string) => {
  return serviceMaker(
    API_ENDPOINTS.update_tax_group.url + `/${id}`,
    API_ENDPOINTS.update_tax_group.method,
    payload,
  );
};
export const GET_TAX_COMPONENT_DDL = () => {
  return serviceMaker(
    API_ENDPOINTS.get_tax_component_ddl.url,
    API_ENDPOINTS.get_tax_component_ddl.method,
  );
};
// ----------------------------end tax Group ---------------------------
